import { useEffect, useState } from "react";

//Componennts
import PodiumUser from "./components/PodiumUser";
import PodiumUserMini from './components/PodiumUserMini'
import PodiumUserMobile from './components/PodiumUserMobile'
import { translate } from "../../localization/translateService";
//Services
import { LoadingService } from "../../helpers/loading";
import { getTutorRanking } from '../../services/tutorLeaderboardService'

//Mockdata
import rankingData from '../../mockData.json';
import { getI18nLanguageFromLocalStorage } from "../../helpers/localStorageHelper";
import NoData from "../nodata/NoData";

export default function RankingLeaderboard({ props }) {

  const [data, setData] = useState([])
  const currentLanguage = getI18nLanguageFromLocalStorage();
  const [translations, setTranslations] = useState({
    noData: "No Data",
  });

  useEffect(() => {
    const loadTranslations = async () => {
      const noData = await translate("MESSAGE.NO_DATA");
      setTranslations({ noData });
    };
    loadTranslations();
  }, []);
  /**
   * Fetches the tutor ranking data from the API.
   * Utilizes the LoadingService to indicate loading state.
   * If the API call fails, mock ranking data is used as a fallback.
   * Updates the component state with the retrieved ranking data.
   */
  const fetchRanking = async () => {
    const requestId = LoadingService.generateId();
    LoadingService.increment("TUTOR RANKING", requestId);
    try {
      // Attempt to fetch ranking data from the API
      //TODO: Add the real API 
      const apiRes = await getTutorRanking();
      const apiData = apiRes?.data || [];
      setData(apiData);
    } catch (e) {
      // Use mock data if API is unavailable or an error occurs
      setData(rankingData);
    } finally {
      // Decrement loading state regardless of outcome
      LoadingService.decrement("TUTOR RANKING", requestId);
    }
  };


  // useEffect to fetch tutor ranking data on mount
  useEffect(() => { fetchRanking(); }, []);

  // Navigates to tutor's detail page when a tutor is selected
  const openTutorDetail = (tutor_id) => { if (tutor_id) window.location = `/${currentLanguage}/real-time-lectures/${tutor_id}`; };

  // Returns the tutor data at the given ranking index.
  const getRankingAtIRank = (index) => {
    if (!data || index > data.length || index < 1) return null;
    return data[index - 1];
  };

  return (
    <div style={{ maxWidth: '1450px', margin: '0 auto' }}>
      {/* Header */}
      <div className="page-title-container">
        <h1 className="keduall-typography heading-h1-semibold-600 text-primary-txt-color mb-075 animate__animated animate__fadeInDown">
          {props?.pageTitle || '튜터 랭킹'}
        </h1>
      </div>

      {/* PC View */}
      <div className="pc-only">
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Top 1 Podium Section */}
          <div className="flex justify-content-center grid">
            {/* 2nd Place (Left) */}
            <div className="col-4 animate__animated animate__bounceInDown">
              {/* 1st Place (Center) */}
              <PodiumUser props={props} rank={1} tutor={getRankingAtIRank(1)} handleClick={openTutorDetail} />
            </div>
          </div>

          {/* Top 2 & 3 Podium Section */}
          <div className="flex justify-content-center grid" style={{ marginTop: '-15vh' }}>
            {/* 2nd Place (Left) */}
            <div className="col-3 animate__animated animate__bounceInLeft">
              <PodiumUser props={props} rank={2} tutor={getRankingAtIRank(2)} handleClick={openTutorDetail} />
            </div>
            <div className="col-3">
              {/* Empty space */}
            </div>
            <div className="col-3 animate__animated animate__bounceInRight">
              <PodiumUser props={props} rank={3} tutor={getRankingAtIRank(3)} handleClick={openTutorDetail} />
            </div>
          </div>

          {/* Top 4 top 6 Podium Section */}
          <div className="flex justify-content-center grid">
            {[4, 5, 6].map(index =>
              <div className="col-3" key={index}>
                <PodiumUser props={props} rank={index} tutor={getRankingAtIRank(index)} handleClick={openTutorDetail} />
              </div>
            )}
          </div>

          {/* Top 7 top 10 Podium Section */}
          <div className="flex justify-content-center grid">
            {[7, 8, 9, 10].map(index =>
              <div className="col-3" key={index}>
                <PodiumUser props={props} rank={index} tutor={getRankingAtIRank(index)} handleClick={openTutorDetail} />
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            width: '100%',
            display: "flex",
            alignItems: "center",
            margin: '30px auto',
            marginBottom: "35px", // to replace mb-6 (optional)          
          }}
        >
          <div
            className="tutor-ranking-separator-section keduall-typography text-16-semibold-600"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px", // Add spacing between image and text
            }}
          >
            <img src={props?.miniRankIcon} style={{ width: 21 }} alt="" />
            <label>{props?.miniRankLabel || '11-20위'}</label>
          </div>
          <hr
            style={{
              flex: 1,
              border: "none",
              height: "2px",
              backgroundColor: "rgb(255, 171, 95)",
              margin: 0,
            }}
          />
        </div>

        {/* Top 11 top 15 Podium Section */}
        <div className="flex justify-content-center grid">
          {[11, 12, 13, 14, 15].map(index =>
            <div className="col-2 p-3" key={index}>
              <PodiumUserMini props={props} rank={index} tutor={getRankingAtIRank(index)} handleClick={openTutorDetail} />
            </div>
          )}
        </div>
        {/* Top 16 top 20 Podium Section */}
        <div className="flex justify-content-center grid">
          {[16, 17, 18, 19, 20].map(index =>
            <div className="col-2 p-3" key={index}>
              <PodiumUserMini props={props} rank={index} tutor={getRankingAtIRank(index)} handleClick={openTutorDetail} />
            </div>
          )}
        </div>
      </div>

      {/* Mobile View */}
      <div className="mobile-only animate__animated animate__fadeIn">
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {data.length === 0 && <NoData message={translations.noData} />}
          {data.map((tutor, index) => (
            <PodiumUserMobile key={index} props={props} rank={index + 1} tutor={getRankingAtIRank(index + 1)} handleClick={openTutorDetail} />
          ))}
        </div>
      </div>
    </div>
  );
}
